<template>
  <div class="form-row align-items-start">
    <div class="form-group col-md-3 mb-3">
      <label class="labelTitle">Country <BaseRequiredField /></label>
      <Multiselect
        v-model="country"
        :options="countries"
        :disabled="isSearching"
        :loading="isSearching"
        :searchable="true"
        selectLabel=""
        placeholder="Select one"
        label="text"
        track-by="value"
        id="country-new"
        @select="onSelectCountry"
        @remove="onRemovingCountry" />
    </div>
    <div class="form-group col-md-3 mb-3">
      <label class="labelTitle">City or Landmark <BaseRequiredField /></label>
      <Multiselect
        :disabled="isSearching || !country"
        v-model="city"
        :options="cities"
        label="text"
        track-by="value"
        selectLabel=""
        placeholder="Type to search"
        open-direction="bottom"
        :searchable="true"
        :allowEmpty="true"
        :loading="searchingCities"
        :internal-search="false"
        :clear-on-select="false"
        :options-limit="300"
        :max-height="200"
        :show-no-results="false"
        :hide-selected="false"
        @search-change="searchCities"
        id="city-new"
        @select="onSelectCity"
        deselectLabel="Press to remove" />
    </div>
    <div class="form-group col-md-6 mtop d-flex justify-content-end">
      <button style="position: relative;top: 0;height: 40px;" type="button" class="btn btn-md btn-secondary btn-sm" @click="upload">
        <font-awesome-icon :icon="['fas', 'search']" />
        Back to images
      </button>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'ImagePickerUpload',
  components: { Multiselect },
  data () {
    return {
      country: this.defaultParams.country || '',
      city: this.defaultParams.city || '',
      keyword: '',
      searchingCities: false,
      cities: this.defaultParams.city ? [ this.defaultParams.city ] : []
    }
  },
  props: {
    isSearching: {
      type: Boolean,
      required: true
    },
    countries: {
      type: [String, Array],
      required: true
    },
    defaultParams: {
      type: Object,
      required: false
    }
  },
  methods: {
    searchCities (query) {
      const minLength = 4
      if (query !== '' && query.length >= minLength) {
        const country = this.country.value
        const payload = { country, query }
        this.searchingCities = true
        this.$store.dispatch('location/searchCities', payload)
          .then(response => {
            if (Array.isArray(response) && response.length > 0) {
              this.cities = []
              this.cities = response
              this.searchingCities = false
            } else {
              this.cities = []
              this.searchingCities = false
            }
          })
          .catch(error => {
            console.log(error)
            this.cities = []
            this.searchingCities = false
          })
      }
    },
    upload () {
      this.$parent.uploading = !this.$parent.uploading
    },
    onSelectCountry (selectedOption, id) {
      this.city = ''
      this.$emit('onSelectCountry', selectedOption)
    },
    onSelectCity (selectedOption, id) {
      this.$emit('onSelectCity', selectedOption)
    },
    onRemovingCountry (selectedOption, id) {
      this.country = ''
      this.city = ''
      this.$emit('onRemovingCountry', selectedOption)
    }
  }
}
</script>

<style lang="scss" scoped>
.mtop {
  margin-top: 25px;
}
</style>
